import { NgModule } from '@angular/core';
import { FormatNumberPipe } from './format-number/format-number';

import { ArticleContentPipe } from './article-content/article-content';

import { FormatDriverTypePipe } from './format-driver-type/format-driver-type';
import { FormatJobTypePipe } from './format-job-type/format-job-type';
import { FormatTrailerTypePipe } from './format-trailer-type/format-trailer-type';
import { FormatPhonePipe } from './format-phone/format-phone';
import { FormatEndorsementsPipe } from './format-endorsements/format-endorsements';
import { FormatMilesTypeLabelPipe } from './format-miles-type-label/format-miles-type-label';
import { FormatMilesTypeValuePipe } from './format-miles-type-value/format-miles-type-value';
import { FormatUserTagsPipe } from './format-userTags/format-userTags';
import { FormatDatetimePipe } from './format-datetime/format-datetime';
import { FormatCompensationPipe } from './format-compensation/format-compensation';
import { FormatBonusPipe } from './format-bonus/format-bonus';
import { FormatHometimePipe } from './format-hometime/format-hometime';
import { FormatPayTypePipe } from './format-pay-type/format-pay-type';
import { FormatJobLocationsPipe } from './format-job-locations/format-job-locations';
import { FormatJobImgPipe } from './format-job-img/format-job-img';
import { FormatHrefTelPipe } from './format-href-tel/format-href-tel';
import { FormatMinExperiencePipe } from './format-min-experience/format-min-experience';
import { ReversePipe } from './reverse/reverse';
import { FilterUserNamesPipe } from './filter-user-names/filter-user-names';
import { ComputeDistancePipe } from './compute-distance/compute-distance';
import { FormatDistancePipe } from './format-distance/format-distance';
import { FormatDurationPipe } from './format-duration/format-duration';
import { KarmaMilesPipe } from './karma-miles/karma-miles';
import { FormatDurationShortPipe } from './format-duration-short/format-duration-short';
import { DistanceAlongTripPipe } from './distance-along-trip/distance-along-trip';
import { PlaceAddressPipe } from './place-address/place-address';
import { FormatGasPricePipe } from './format-gas-price/format-gas-price';
import { FormatHeightPipe } from './format-height/format-height';
import { RecommendPercentPipe } from './recommend-percent/recommend-percent';
import { UserReportedReviewPipe } from './user-reported-review/user-reported-review';
import { FormatSecondsToMinutesPipe } from './format-seconds-minutes/format-seconds-minutes';
import { FormatMaxWeightPipe } from './format-max-weight/format-max-weight';
import { FormatTruckDetailsPipe } from './format-truck-details/format-truck-details';
import { GetDefaultPlaceImagePipe } from './get-default-place-image/get-default-place-image';
import { FormatWreckerTagsPipe } from './format-wrecker-tags/format-wrecker-tags.pipe';
import { LeaderboardCountsPipe } from './leaderboard-counts/leaderboard-counts';
import { BadgesFilterPipe } from './badges-filter/badges-filter';
import { IndexOfPipe } from './index-of/index-of';
import { OpenNowPipe } from './open-now/open-now';
import { FormatTempPipe } from './format-temp/format-temp';
import { FormatWindDirectionPipe } from './format-wind-direction/format-wind-direction';
import { WeatherConditionsPipe } from './weather-conditions/weather-conditions';
import { LodashPipe } from './lodash/lodash';
import { EllipsesTextPipe } from './ellipses-text/ellipses-text';
import { ResizeImagePipe } from './resize-image/resize-image';
import { AdnSettingsPipe } from './adn-settings/adn-settings';
import { OnlineIndicatorPipe } from './online-indicator/online-indicator';
import { SliceMessagePipe } from './splice-text/splice-message';
import { HasReportedPipe } from './has-reported/has-reported';
import { LCIsMutedPipe } from './lc-is-muted/lc-is-muted';
import { TaggedUsersPipe } from './tagged-users/tagged-users';
import { StripHtmlPipe } from './strip-html/strip-html';
import { SvgSanitize } from './svg-sanitize/svg-sanitize';
import { ParseReplaceDatetimePipe } from './parse-replace-datetime/parse-replace-datetime';

@NgModule({
  declarations: [
    FormatNumberPipe,
    ArticleContentPipe,
    FormatDriverTypePipe,
    FormatJobTypePipe,
    FormatTrailerTypePipe,
    FormatPhonePipe,
    FormatEndorsementsPipe,
    FormatMilesTypeLabelPipe,
    FormatMilesTypeValuePipe,
    FormatUserTagsPipe,
    FormatDatetimePipe,
    FormatCompensationPipe,
    FormatBonusPipe,
    FormatHometimePipe,
    FormatPayTypePipe,
    FormatJobLocationsPipe,
    FormatJobImgPipe,
    FormatHrefTelPipe,
    FormatMinExperiencePipe,
    ReversePipe,
    FilterUserNamesPipe,
    ComputeDistancePipe,
    FormatDistancePipe,
    FormatDurationPipe,
    KarmaMilesPipe,
    FormatDurationShortPipe,
    FormatDurationShortPipe,
    DistanceAlongTripPipe,
    PlaceAddressPipe,
    FormatGasPricePipe,
    FormatHeightPipe,
    RecommendPercentPipe,
    UserReportedReviewPipe,
    FormatSecondsToMinutesPipe,
    FormatMaxWeightPipe,
    FormatTruckDetailsPipe,
    GetDefaultPlaceImagePipe,
    FormatWreckerTagsPipe,
    LeaderboardCountsPipe,
    BadgesFilterPipe,
    IndexOfPipe,
    OpenNowPipe,
    FormatTempPipe,
    FormatWindDirectionPipe,
    WeatherConditionsPipe,
    LodashPipe,
    EllipsesTextPipe,
    ResizeImagePipe,
    AdnSettingsPipe,
    OnlineIndicatorPipe,
    SliceMessagePipe,
    HasReportedPipe,
    LCIsMutedPipe,
    TaggedUsersPipe,
    StripHtmlPipe,
    SvgSanitize,
    ParseReplaceDatetimePipe
  ],
  imports: [],
  exports: [
    FormatNumberPipe,
    ArticleContentPipe,
    FormatDriverTypePipe,
    FormatJobTypePipe,
    FormatTrailerTypePipe,
    FormatPhonePipe,
    FormatEndorsementsPipe,
    FormatMilesTypeLabelPipe,
    FormatMilesTypeValuePipe,
    FormatUserTagsPipe,
    FormatDatetimePipe,
    FormatCompensationPipe,
    FormatBonusPipe,
    FormatHometimePipe,
    FormatPayTypePipe,
    FormatJobLocationsPipe,
    FormatJobImgPipe,
    FormatHrefTelPipe,
    FormatMinExperiencePipe,
    ReversePipe,
    FilterUserNamesPipe,
    ComputeDistancePipe,
    FormatDistancePipe,
    FormatDurationPipe,
    KarmaMilesPipe,
    FormatDurationShortPipe,
    FormatDurationShortPipe,
    DistanceAlongTripPipe,
    PlaceAddressPipe,
    FormatGasPricePipe,
    FormatHeightPipe,
    RecommendPercentPipe,
    UserReportedReviewPipe,
    FormatSecondsToMinutesPipe,
    FormatMaxWeightPipe,
    FormatTruckDetailsPipe,
    GetDefaultPlaceImagePipe,
    FormatWreckerTagsPipe,
    LeaderboardCountsPipe,
    BadgesFilterPipe,
    IndexOfPipe,
    OpenNowPipe,
    FormatTempPipe,
    FormatWindDirectionPipe,
    WeatherConditionsPipe,
    LodashPipe,
    EllipsesTextPipe,
    ResizeImagePipe,
    AdnSettingsPipe,
    OnlineIndicatorPipe,
    SliceMessagePipe,
    HasReportedPipe,
    LCIsMutedPipe,
    TaggedUsersPipe,
    StripHtmlPipe,
    SvgSanitize,
    ParseReplaceDatetimePipe
  ],
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts